<template>
<div class="ecology-domain">
  <div class="content">
    <h2>建设领域方向</h2>
    <div class="content-box">
      <div class="card">
        <img src="@/assets/img/2.0/ecology/topImg1.png" alt="" />
        <div class="card-info">
          <div class="title">开源鸿蒙创新测试实验室</div>
          <div class="item">
            <div><img src="@/assets/img/2.0/ecology/gou.png" alt="">领域方向</div>
            <p>重点面向自身和生态伙伴提供开源鸿蒙硬件防静电等级、绝缘耐压、群脉冲、温升、浪涌、电源、信号波等50余项可靠性和性能产品上市预测试、技术支持产品迭代等服务。</p>
          </div>
          <div class="item">
            <div><img src="@/assets/img/2.0/ecology/gou.png" alt="">解决问题</div>
            <p>中软国际自研和与合作伙伴联创开源鸿蒙硬件产品测试服务及部分性能开发的需求。</p>
          </div>
        </div>
      </div>
      <div class="card">
        <img src="@/assets/img/2.0/ecology/topImg2.png" alt="" />
        <div class="card-info">
          <div class="title">全系感知城市生命线模拟测试环境实验室</div>
          <div class="item">
            <div><img src="@/assets/img/2.0/ecology/gou.png" alt="">领域方向</div>
            <p>建设可燃气体检测、城市内涝及供水爆管、底下综合管廊、道桥健康监测等城市生命线的产品研发及模拟测试环境。</p>
          </div>
          <div class="item">
            <div><img src="@/assets/img/2.0/ecology/gou.png" alt="">解决问题</div>
            <p>中软国际联合郑州高新区及合作伙伴打造“全系城市生命线”示范场景，将建设的基于开源鸿蒙的城市物联感知系统及自主可控技术领先新型数字基础设施在郑州高新区发布。此实验室解决产品碎片化、非自主可控、标准不统一等问题，以及本地化场景模拟测试展示及部分性能开发的需求。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "ecologyDomain"
}
</script>


<style scoped lang="scss">
.ecology-domain{
  background: #FFF;
  .content{
    width: 1280px;
    margin: 0 auto;
    padding: 64px 0;
    >h2{
      font-weight: 500;
      font-size: 32px;
      color: #262626;
      line-height: 45px;
      text-align: center;
      margin-bottom: 48px;
    }
    .content-box{
      display: flex;
      justify-content: space-between;
      >.card{
        width: 628px;
        height: 488px;
        background: #FFFFFF;
        display: flex;
        flex-direction: column;
        >img{
          width: 100%;
        }
        .card-info{
          flex: 1;
          border: 1px solid #E6E6E6;
          border-top: none;
          padding: 24px;
          .title{
            font-weight: 500;
            font-size: 18px;
            color: #323233;
            line-height: 24px;
          }
          .item{
            >div{
              display: flex;
              align-items: center;
              font-weight: 500;
              font-size: 14px;
              color: #323233;
              line-height: 20px;
              margin-bottom: 16px;
              >img{
                margin-right: 8px;
              }
            }
            >p{
              font-weight: 400;
              font-size: 14px;
              color: #323233;
              line-height: 20px;
            }
          }
          >:not(:last-child){
            margin-bottom: 24px;
          }
        }
      }
    }
  }
}
</style>
